import Marquee from 'react-fast-marquee';
import { MARQUEE_WORDS } from '../../lib/site-data';

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-ink-900 py-10 md:py-14 border-y border-white/10 overflow-hidden"
    >
      <Marquee gradient={false} speed={75} pauseOnHover className="py-2">
        {MARQUEE_WORDS.map((w, i) => (
          <span
            key={`${w}-${i}`}
            className="mx-8 flex items-center gap-8 display-heading text-6xl md:text-8xl lg:text-9xl uppercase tracking-tightest"
            style={{ letterSpacing: '-0.055em', fontWeight: 900 }}
          >
            <span className={i % 2 === 0 ? 'stroke-text' : 'text-white'}>{w}</span>
            <span className="text-signal-500 text-2xl md:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
